
// $(".ct-announcement-content").marquee({
//     direction: "left",
//     duration: 25e3,
//     gap: 0,
//     delayBeforeStart: 0,
//     duplicated: !0,
//     startVisible: !0
// });

$(".dev-announcement").show(),
$('.ct-announcement-content').marquee({
    direction: 'left',
    duration: 30000,
    gap: 0,
    delayBeforeStart: 0,
    duplicated: true,
    startVisible: true
});



  var swiper = new Swiper(".banner_slider", {
    loop:true,
      pagination: {
        el: ".swiper-pagination",
        // dynamicBullets: true,
      },
    });



 var swiper = new Swiper(".pro_slider", {
  slidesPerView: 4,  // default for 1280+
  spaceBetween: 20,
  navigation: {
    nextEl: ".next_arrow",
    prevEl: ".prew_arrow",
  },
  breakpoints: {
    1280: {
      slidesPerView: 4,  // 1280px se upar
    },
    750: {
      slidesPerView: 3,  // 750px se upar
    },
    0: {
      slidesPerView: 'auto',  // 0 se 749px tak
    },
  }
});


var swiper = new Swiper(".pdp_discounts_swiper", {
    slidesPerView: 1.1,
    spaceBetween: 10, 
    navigation: false,
    pagination: false,
    breakpoints: {
      749: {
        slidesPerView: 1.2,
        spaceBetween: 10
      },
      1025: {
        slidesPerView: 1.5,
        spaceBetween: 16
      }
  }
  });




  jQuery(document).ready(function($) {
  $(document).on('click', '.gokwik-checkout', function (e) {
    $('.cart-drawer__close-button').trigger('click');
    // console.log('gokwik-checkout clicked — drawer close triggered');
  });
});